export default "__VITE_ASSET__D0a8i$3n__"